import React from "react";
import Text from "components/common/Text";
import GlobalLoader from "components/common/GlobalLoader";
import FireberryIcon from "images/FLogo.svg";
import * as Constant from "constant";
import * as S from "./style";

function MobileCreatingScreen(props) {
  return (
    <S.MobileCreatingScreenContainer>
      <S.MobileContentContainer>
        <S.LogoContainer>
          <S.Img src={FireberryIcon} width={"40px"} />
        </S.LogoContainer>
        <S.MobileHeadlinesContainer>
          <Text size={Constant.SIZE._5xl} bold>
            {props.headline}
          </Text>
          <Text size={Constant.SIZE.xxl}>{props.secondaryHeadline}</Text>
        </S.MobileHeadlinesContainer>
        <S.MobileLoaderContainer>
          <GlobalLoader isLoading value={50} />
        </S.MobileLoaderContainer>
      </S.MobileContentContainer>
    </S.MobileCreatingScreenContainer>
  );
}

export default MobileCreatingScreen;
